import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Rest of your imports...
import { createApp, h } from 'vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import axios from './axios';

// Other imports...
import 'slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';
import 'maz-ui/css/main.css'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Toast, { POSITION } from "vue-toastification";
import App from './App.vue';

const app = createApp({
    render: () => h(App)
});

app.config.globalProperties.$http = axios;

app.use(router)
    .use(store)
    .use(Toast, {
        position: POSITION.TOP_RIGHT,
        timeout: 3000,
        closeOnClick: true,
        pauseOnHover: true,
    })
    .use(i18n)
    // .component('Select2', Select2)
    .component('VuePhoneNumberInput', VuePhoneNumberInput);

app.mount('#app');